export default __webpack_public_path__ + "static/media/on.a715035e.svg";